<template>

  <div>
    <!--text-->
    <div v-if="type === 'text'">
      <input
        class="form-control"
        type="text"
        v-model="val">
    </div>

    <!--textarea-->
    <div v-if="type === 'textarea'">
      <textarea
        class="form-control"
        v-model="val"></textarea>
    </div>

    <!--radio-->
    <div v-if="type === 'radio'">

      <div
        class="form-check"
        v-for="(option, index) in options"
        :key="index">

        <input
        class="form-check-input"
        type="radio"
        :value="option"
        v-model="val">
        <label class="form-check-label">
          {{ option }}
        </label>
      
      </div>

    </div>

    <!--checkbox-->
    <div v-if="type === 'checkbox'">
      
      <div
        class="form-check"
        v-for="(option, index) in options"
        :ley="index">
        
        <input
          class="form-check-input"
          type="checkbox"
          :value="option"
          v-model="val">
        <label class="form-check-label">
          {{ option }}
        </label>
      
      </div>
      
    </div>

    <!--select-->
    <div v-if="type === 'select'">

      <select
        class="form-control"
        v-model="val">
        <option
          v-for="(option, index) in options"
          :key="index"
          :value="option">{{ option }}</option> 
      </select>

    </div>

    <!--date-->
    <div v-if="type === 'date'">

      <date  
        :setting="{format: 'DD-MM-YYYY'}"
        v-model="val">
        </date>

    </div>

    <!--number-->
    <div v-if="type === 'number'">
      <input
        class="form-control"
        type="number"
        v-model="val">
    </div>
  </div>

</template>

<script>
import Date from './Date'

export default {
  name: 'InputCustomField',
  components: {
    Date
  },
  props: [
    'type',
    'value',
    'options'
  ],
  data () {
    var value = this.value
    if ((this.type === 'checkbox') && typeof (value) !== 'object') value = []

    return {
      'val': value
    }
  },
  watch: {
    'val': function (val, oldVal) {
      this.$emit('input', val)
    },
    'value': function (val, oldVal) {
      this.val = val
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/InputCustomField.vue